import {DashboardConstants} from "../actionTypes/dashboard.constant";

const InitialState = {
    numPages: 1,
    isBusy: false, 
    drawerCollapsed: false
}

export const dashboardReducer = ( state = InitialState , action) => {
    switch(action.type){
        case DashboardConstants.CHANGE_PAGE:
            return {
                ...state, 
                pageNumber: action.pageNumber
            }
        case DashboardConstants.CHANGE_TOTAL_NUMBER_OF_PAGES:
            return {
                ...state, 
                numPages: action.numPages
            }
        case DashboardConstants.SET_BUSY:
            return {
                ...state, 
                isBusy: true
            }
        case DashboardConstants.SET_IDLE:
            return {
                ...state, 
                isBusy: false
            }
        case DashboardConstants.CLOSE_DRAWER:
            return {
                ...state, 
                drawerCollapsed: true
            }
        case DashboardConstants.OPEN_DRAWER:
            return {
                ...state, 
                drawerCollapsed: false
            }
        default :
            return state
    }
}